import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, btnRust } from "./data";
import { Rise } from "./motion";
import { scrollTo } from "./scroll";

const FinalCTA = () => (
  <section
    data-testid="final-cta-section"
    className="border-b-2 border-ink bg-ink text-paper"
  >
    <div className="mx-auto max-w-[1500px] px-4 py-24 sm:px-6 lg:py-36">
      <Rise>
        <p className="font-hand text-2xl text-polered sm:text-3xl">
          Walk in. Get sorted.
        </p>
      </Rise>
      <Rise delay={0.1}>
        <h2 className="mt-4 font-display text-[15vw] uppercase leading-[0.82] sm:text-[11vw] lg:text-[11rem]">
          Need a<br />
          fresh cut?
        </h2>
      </Rise>

      <Rise delay={0.2}>
        <div className="mt-12 flex flex-wrap items-center gap-6">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("#contact");
            }}
            data-testid="final-walkin-button"
            className={`${btnRust} border-paper shadow-hard-paper`}
          >
            Walk in today
          </a>
        </div>
      </Rise>

      <Rise delay={0.3}>
        <a
          href={PHONE_TEL}
          data-testid="final-phone-link"
          className="mt-14 inline-flex flex-wrap items-center gap-4 border-y-2 border-paper/25 py-6 font-display text-[9vw] uppercase leading-none transition-colors hover:text-rust sm:text-7xl lg:text-8xl"
        >
          <Phone className="h-[0.7em] w-[0.7em]" strokeWidth={2.5} />
          {PHONE_DISPLAY}
        </a>
      </Rise>
    </div>
  </section>
);

export default FinalCTA;
